export const common = {
  english: "Anglais",
  french: "Français",
  moreDetails: "Plus de détails",
  visit: "Visitez",
  contact: "à venir bientôt",
  dark: "Sombre",
  light: "Clair",
};

export const landing = {
  sub1: "full stack; développement de",
  sub1b: "sites",
  sub2: "et",
  sub2b: "d'applications mobiles",
  sub3: "",
};

export const huehear = {
  desc: `<p>
  Un lecteur de musique web avec un twist!
  HueHear est un projet personnel que j'ai commencé fin 2019 pour divertir mes amis. Cette application web compatible Apple Music et Spotify créé un environnement ambiant grâce aux pochettes d'album des musiques écoutées. Les couleurs primaires sont extraites de la pochette puis sont envoyées aux ampoules connectées Phillips Hue.
  <br/>
  <br/>
  Dansez aux couleurs de vos artistes!
</p>`,
};
export const strainprint = {
  desc: `<p>
  Strainprint aide les patients consommant du cannabis à suivre et comparer les souches et les effets qu'ils ressentent. Avec une grande collection de produits et de méthodes pour suivre vos symptômes, trouver les produits les plus efficaces devient plus accessible.
  <br/>
  <br/>
  Strainprint est une reconstruction de l'original, maintenant construite en React Native; Sortie sous forme d'une mise à jour le Fevrier 2021.
  <br/>
  <br/>
  Decouvrez l'application pour savoir plus!
</p>`,
};
export const cobbl = {
  desc: `  <p>
  En vedette dans le <a href="https://angelhack.com/" target="_blank">AngelHack HACKcelerator</a> en 2018, cobbl etait un application iOS/Android qui montré les règles actuelles de stationnement ou vous vous trouver.
</p>`,
};
export const sewingarmy = {
  desc:
    "L'application Web Sewing Army a été conçue pour aider à connecter la merveilleuse communauté de couturiers à travers l'Amérique du Nord afin de livrer l'équipement d'EPI là où il est le plus nécessaire!",
};

export const category = {
  web: "./DÉV WEB",
  app: "./DÉV de APP",
};
